import type { MediaItem } from "@/types/media";

export const mediaList: MediaItem[] = [
  {
    id: "m01",
    title: "雾城疑影",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Foggy%20rainy%20city%20street%20at%20night%20with%20a%20lone%20detective%20silhouette%20in%20a%20trench%20coat%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-m01&orientation=portrait",
    genre: ["悬疑", "犯罪"],
    region: "国产",
    year: 2025,
    duration: "128 分钟",
    status: "已完结",
    rating: 8.6,
    views: 1280000,
    synopsis:
      "连环失踪案笼罩雾城，落魄侦探周慕白被迫重返警队。随着线索层层揭开，他发现所有受害者都与十年前那场未结火灾有关。真相藏在自己最不愿触碰的记忆里，一场关于救赎与谎言的博弈就此展开。",
    director: "陈砚舟",
    cast: ["沈知远", "林晚清", "周慕白"],
    updatedAt: "2025-09-28",
    tags: ["新片"],
  },
  {
    id: "m02",
    title: "光尘纪年",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Lone%20astronaut%20standing%20before%20a%20giant%20glowing%20planet%20horizon%20in%20deep%20space%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-m02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Lone%20astronaut%20standing%20before%20a%20giant%20glowing%20planet%20horizon%20in%20deep%20space%2Ccinematic%20wide%20film%20still%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20epic%20composition&width=1600&height=900&seq=ggyx-bd-m02&orientation=landscape",
    genre: ["科幻", "冒险"],
    region: "欧美",
    year: 2026,
    duration: "145 分钟",
    status: "已上映",
    rating: 8.9,
    views: 2140000,
    synopsis:
      "人类最后一批深空探险队抵达未知星系，却在一颗古老行星上发现了与自己文明完全相同的倒塌遗迹。当时间与记忆开始错位，队长必须决定：是带回真相，还是让整个文明重蹈覆辙。",
    director: "亚瑟·凯恩",
    cast: ["卢卡斯·格雷", "艾米·福特", "诺兰·里德"],
    updatedAt: "2026-01-12",
    tags: ["新片"],
  },
  {
    id: "m03",
    title: "山海旧梦",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Ancient%20mountain%20and%20sea%20fantasy%20landscape%20with%20a%20mythical%20beast%20and%20floating%20islands%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-m03&orientation=portrait",
    genre: ["奇幻", "古装"],
    region: "国产",
    year: 2024,
    duration: "132 分钟",
    status: "已完结",
    rating: 8.1,
    views: 970000,
    synopsis:
      "传说山海之间藏着能改写命运的旧梦石。少女白清欢为救族人性命踏上寻石之旅，与背负血债的剑客并肩而行。当真相揭开，她必须在复仇与慈悲之间做出抉择。",
    director: "苏景桓",
    cast: ["江疏月", "顾南舟", "白清欢"],
    updatedAt: "2024-11-05",
  },
  {
    id: "m04",
    title: "极速边界",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=High%20speed%20race%20car%20drifting%20on%20a%20neon%20night%20highway%20with%20motion%20blur%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-m04&orientation=portrait",
    genre: ["动作", "运动"],
    region: "港台",
    year: 2025,
    duration: "118 分钟",
    status: "已完结",
    rating: 8.3,
    views: 1420000,
    synopsis:
      "退役车手程亦飞被卷回地下赛车世界，为洗清兄弟冤屈再次握紧方向盘。每一次漂移都是与死神的擦肩，终点线背后隐藏的却是一场精心策划的阴谋。",
    director: "徐正尧",
    cast: ["程亦飞", "何芷晴", "郑铠"],
    updatedAt: "2025-08-20",
  },
  {
    id: "m05",
    title: "夏日橘子海",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Young%20couple%20on%20a%20sunny%20orange%20beach%20at%20golden%20hour%20with%20soft%20warm%20light%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-m05&orientation=portrait",
    genre: ["爱情", "青春"],
    region: "国产",
    year: 2025,
    duration: "108 分钟",
    status: "已完结",
    rating: 7.9,
    views: 860000,
    synopsis:
      "海边的橘子摊、褪色的旧相机和一整个夏天的心动。高考后的两人约定在橘子海重逢，却不知一场离别已在站台悄然等候。青春里最遗憾的，往往是最美好的。",
    director: "温以宁",
    cast: ["夏之澜", "陆时宴"],
    updatedAt: "2025-07-18",
  },
  {
    id: "m06",
    title: "沉默的证词",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Shadowy%20courtroom%20corridor%20with%20a%20silent%20witness%20figure%20and%20cold%20blue%20light%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-m06&orientation=portrait",
    genre: ["犯罪", "悬疑"],
    region: "日韩",
    year: 2024,
    duration: "122 分钟",
    status: "已完结",
    rating: 8.4,
    views: 1130000,
    synopsis:
      "一场没有目击者的谋杀，一位拒绝开口的证人。年轻检察官在追查真相的过程中，逐渐发现自己手中的证词竟来自最不该出现的人。沉默，有时是最响亮的控诉。",
    director: "井上凉",
    cast: ["佐藤健吾", "中村麻衣"],
    updatedAt: "2024-10-30",
  },
  {
    id: "m07",
    title: "机械黎明",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Giant%20mechanical%20robot%20rising%20at%20dawn%20in%20a%20futuristic%20ruined%20city%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-m07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Giant%20mechanical%20robot%20rising%20at%20dawn%20in%20a%20futuristic%20ruined%20city%2Ccinematic%20wide%20film%20still%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20epic%20composition&width=1600&height=900&seq=ggyx-bd-m07&orientation=landscape",
    genre: ["科幻", "动作"],
    region: "欧美",
    year: 2025,
    duration: "150 分钟",
    status: "已上映",
    rating: 8.7,
    views: 1870000,
    synopsis:
      "当第一台拥有自我意识的机械体在黎明苏醒，人类与机器的界限开始崩塌。工程师伊莲娜必须在军方的猎杀令下达前，证明它究竟是武器，还是新生命的开始。",
    director: "艾登·科尔",
    cast: ["马克·萨维尔", "伊莲娜·沃德"],
    updatedAt: "2025-12-24",
    tags: ["新片"],
  },
  {
    id: "m08",
    title: "长街灯火",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20old%20town%20street%20glowing%20with%20lantern%20lights%20at%20dusk%20with%20a%20family%20walking%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-m08&orientation=portrait",
    genre: ["剧情", "家庭"],
    region: "国产",
    year: 2024,
    duration: "116 分钟",
    status: "已完结",
    rating: 8.0,
    views: 640000,
    synopsis:
      "老街即将拆迁，经营面馆三十年的老傅决定再做最后一夜生意。四面八方的老邻居循着灯光而来，一碗碗热面里盛着的是说不出口的告别与牵挂。",
    director: "柳青禾",
    cast: ["傅长风", "宋语乔"],
    updatedAt: "2024-09-14",
  },
  {
    id: "m09",
    title: "追风者归来",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Lone%20runner%20sprinting%20through%20wind%20and%20dust%20on%20a%20mountain%20road%20at%20sunset%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-m09&orientation=portrait",
    genre: ["运动", "剧情"],
    region: "国产",
    year: 2025,
    duration: "125 分钟",
    status: "已完结",
    rating: 8.2,
    views: 720000,
    synopsis:
      "因伤退役的马拉松冠军回到高原故乡，遇见了同样在追梦的少年。为了带他跑完那段最艰难的上坡，老将与新人踏上了一段关于坚持与传承的旅程。",
    director: "韩昱",
    cast: ["萧宇翔", "叶知秋"],
    updatedAt: "2025-06-08",
  },
  {
    id: "m10",
    title: "迷雾灯塔",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Lighthouse%20on%20a%20misty%20cliff%20at%20night%20with%20crashing%20waves%20and%20eerie%20fog%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-m10&orientation=portrait",
    genre: ["悬疑", "惊悚"],
    region: "欧美",
    year: 2024,
    duration: "110 分钟",
    status: "已完结",
    rating: 8.5,
    views: 1310000,
    synopsis:
      "孤岛灯塔的看守人失踪后，接替者每晚都会收到来自海上的神秘信号。随着浓雾一天天逼近，他终于明白：有些灯塔照亮航路，有些却照见人心最深的恐惧。",
    director: "格蕾丝·米勒",
    cast: ["科尔·戴维斯", "娜塔莉·格林"],
    updatedAt: "2024-12-02",
  },
  {
    id: "m11",
    title: "沙漠之约",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Endless%20golden%20desert%20dunes%20with%20two%20travelers%20and%20a%20distant%20caravan%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-m11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Endless%20golden%20desert%20dunes%20with%20two%20travelers%20and%20a%20distant%20caravan%2Ccinematic%20wide%20film%20still%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20epic%20composition&width=1600&height=900&seq=ggyx-bd-m11&orientation=landscape",
    genre: ["冒险", "剧情"],
    region: "欧美",
    year: 2026,
    duration: "138 分钟",
    status: "已上映",
    rating: 8.6,
    views: 990000,
    synopsis:
      "一位寻找失落水源的地质学家雇佣了沉默的向导，两人穿越死亡之海。当沙暴抹去所有路标，他们只能依靠对彼此的信任，去兑现那个二十年前的约定。",
    director: "奥马尔·哈立德",
    cast: ["伊桑·布莱克", "莱拉·侯赛因"],
    updatedAt: "2026-02-14",
    tags: ["新片"],
  },
  {
    id: "m12",
    title: "时光邮差",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Vintage%20postman%20on%20a%20bicycle%20delivering%20letters%20in%20a%20timeless%20dreamy%20town%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-m12&orientation=portrait",
    genre: ["爱情", "奇幻"],
    region: "日韩",
    year: 2025,
    duration: "104 分钟",
    status: "已完结",
    rating: 8.1,
    views: 700000,
    synopsis:
      "小镇邮差发现自己能投递寄往过去的信件。为了挽回一段错过的爱情，他一次次修改信笺上的日期，却不知每一次更改，都会让未来悄悄偏离原来的模样。",
    director: "松本优",
    cast: ["山崎遥", "高桥玲"],
    updatedAt: "2025-03-22",
  },
  {
    id: "t01",
    title: "长安夜行录",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20capital%20city%20at%20night%20with%20lanterns%20and%20a%20cloaked%20figure%20on%20a%20rooftop%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-t01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20capital%20city%20at%20night%20with%20lanterns%20and%20a%20cloaked%20figure%20on%20a%20rooftop%2Ccinematic%20wide%20film%20still%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20epic%20composition&width=1600&height=900&seq=ggyx-bd-t01&orientation=landscape",
    genre: ["古装", "悬疑"],
    region: "国产",
    year: 2025,
    duration: "40 集",
    status: "全集",
    rating: 9.0,
    views: 3260000,
    synopsis:
      "盛唐长安，暗夜之下暗流涌动。少年提刑官温临渊与女仵作苏挽月联手勘破一桩桩离奇命案，却发现所有线索都指向朝堂深处一个被刻意掩埋的名字。",
    director: "裴惊鸿",
    cast: ["温临渊", "苏挽月", "陆星野"],
    updatedAt: "2025-09-30",
    tags: ["热门"],
  },
  {
    id: "t02",
    title: "都市回声",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20reflected%20in%20a%20rainy%20window%20with%20a%20thoughtful%20young%20person%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-t02&orientation=portrait",
    genre: ["都市", "爱情"],
    region: "国产",
    year: 2025,
    duration: "36 集",
    status: "更新至 30 集",
    rating: 8.3,
    views: 1780000,
    synopsis:
      "三个在都市打拼的年轻人，因一间深夜电台而命运交汇。每当午夜钟声响起，他们都会把心事念给城市听。生活的回声，总在最意想不到的时刻给出答案。",
    director: "秦昭",
    cast: ["方知遥", "顾时安"],
    updatedAt: "2025-10-02",
  },
  {
    id: "t03",
    title: "深海行动",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Deep%20sea%20submarine%20interior%20with%20alarm%20red%20light%20and%20tense%20crew%20silhouettes%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-t03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Deep%20sea%20submarine%20interior%20with%20alarm%20red%20light%20and%20tense%20crew%20silhouettes%2Ccinematic%20wide%20film%20still%2C%20dramatic%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20epic%20composition&width=1600&height=900&seq=ggyx-bd-t03&orientation=landscape",
    genre: ["悬疑", "动作"],
    region: "欧美",
    year: 2025,
    duration: "24 集",
    status: "全集",
    rating: 8.8,
    views: 2050000,
    synopsis:
      "一艘失联多年的深海潜艇突然发出求救信号，国际救援队奉命下潜。随着深度增加，通信中断、声呐失灵，队员们开始怀疑：发出信号的，究竟是不是人类。",
    director: "本·卡特",
    cast: ["杰克·莫兰", "索菲亚·雷诺"],
    updatedAt: "2025-08-15",
    tags: ["热门"],
  },
  {
    id: "t04",
    title: "星辰学院",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Futuristic%20academy%20campus%20with%20glowing%20holograms%20and%20students%20under%20a%20starry%20sky%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-t04&orientation=portrait",
    genre: ["青春", "科幻"],
    region: "日韩",
    year: 2024,
    duration: "20 集",
    status: "全集",
    rating: 8.0,
    views: 1120000,
    synopsis:
      "在培养星际领航员的星辰学院，一群天才少年接受着最严苛的训练。表面平静的校园下，隐藏着一个会颠覆整个星系的秘密，而它正等待着最不起眼的新生去揭开。",
    director: "佐伯绫",
    cast: ["佐藤健吾", "中村麻衣"],
    updatedAt: "2024-07-10",
  },
  {
    id: "t05",
    title: "边境迷踪",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Empty%20foggy%20border%20road%20at%20dawn%20with%20a%20police%20car%20and%20searchlights%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-t05&orientation=portrait",
    genre: ["犯罪", "悬疑"],
    region: "欧美",
    year: 2026,
    duration: "16 集",
    status: "更新至 08 集",
    rating: 8.9,
    views: 1560000,
    synopsis:
      "一桩跨越两国边境的走私案，把昔日搭档推到了对立面。当正义与法律的界限在迷雾中模糊，他们必须选择是追随规则，还是追随真相。",
    director: "卡拉·门德斯",
    cast: ["迭戈·罗哈斯", "露西亚·费尔南德斯"],
    updatedAt: "2026-01-20",
    tags: ["新片"],
  },
  {
    id: "t06",
    title: "家常岁月",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Cozy%20traditional%20family%20home%20kitchen%20with%20warm%20steam%20and%20soft%20evening%20light%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-t06&orientation=portrait",
    genre: ["家庭", "剧情"],
    region: "国产",
    year: 2024,
    duration: "32 集",
    status: "全集",
    rating: 8.4,
    views: 980000,
    synopsis:
      "从老屋的灶台到城市的厨房，一个普通家庭三十年来的柴米油盐。时代在变，饭桌在变，唯有那些家常的味道和牵挂，从未走远。",
    director: "何清扬",
    cast: ["宋语乔", "傅长风", "温以宁"],
    updatedAt: "2024-06-18",
  },
  {
    id: "t07",
    title: "暗流涌动",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Old%20Shanghai%20era%20street%20at%20night%20with%20rain%20and%20a%20spy%20in%20a%20fedora%20hat%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-t07&orientation=portrait",
    genre: ["谍战", "悬疑"],
    region: "国产",
    year: 2025,
    duration: "38 集",
    status: "更新至 22 集",
    rating: 8.7,
    views: 1890000,
    synopsis:
      "风雨飘摇的年代，一个代号「青鸟」的潜伏者游走在敌我之间。当最信任的战友身份成谜，他必须在暗流中独自守住那条随时会断裂的暗线。",
    director: "沈墨白",
    cast: ["陆星野", "苏挽月"],
    updatedAt: "2025-10-05",
    tags: ["热门"],
  },
  {
    id: "t08",
    title: "绿水青山记",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Lush%20green%20terraced%20rice%20fields%20in%20a%20peaceful%20village%20at%20sunrise%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-t08&orientation=portrait",
    genre: ["剧情", "乡村"],
    region: "国产",
    year: 2024,
    duration: "28 集",
    status: "全集",
    rating: 8.5,
    views: 760000,
    synopsis:
      "返乡青年用一腔热血，带领贫穷山村走上生态致富之路。从被质疑到被信任，他用行动证明：守住绿水青山，就是守住子孙后代的饭碗。",
    director: "柳青禾",
    cast: ["方知遥", "何清扬"],
    updatedAt: "2024-05-12",
  },
  {
    id: "t09",
    title: "医者仁心路",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Bright%20hospital%20corridor%20with%20a%20dedicated%20doctor%20in%20a%20white%20coat%20and%20blue%20tones%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-t09&orientation=portrait",
    genre: ["医疗", "都市"],
    region: "国产",
    year: 2025,
    duration: "30 集",
    status: "更新至 26 集",
    rating: 8.6,
    views: 1340000,
    synopsis:
      "急诊科里的每一次抢救都是与时间赛跑。年轻的主治医师在高压与质疑中成长，逐渐读懂白大褂背后的重量——医术之外，更需要一颗仁心。",
    director: "秦昭",
    cast: ["顾时安", "叶知秋"],
    updatedAt: "2025-09-25",
  },
  {
    id: "t10",
    title: "未来合伙人",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20startup%20office%20at%20night%20with%20young%20partners%20and%20city%20lights%20outside%2Ccinematic%20film%20key%20art%2C%20dramatic%20moody%20lighting%2C%20deep%20blue%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20haze%2C%20subtle%20film%20grain%2C%20high%20detail%2C%20no%20text%20or%20letters%2C%20professional%20vertical%20poster%20composition%2C%20dark%20background%20with%20soft%20glow&width=420&height=630&seq=ggyx-t10&orientation=portrait",
    genre: ["都市", "剧情"],
    region: "国产",
    year: 2026,
    duration: "24 集",
    status: "更新至 10 集",
    rating: 8.2,
    views: 680000,
    synopsis:
      "三个背景迥异的年轻人在一间狭小办公室里立下创业誓言。资金、信任与理想的反复拉扯中，他们既是对手，也是彼此最坚实的合伙人。",
    director: "韩昱",
    cast: ["萧宇翔", "夏之澜"],
    updatedAt: "2026-02-01",
    tags: ["新片"],
  },
];